import { useEffect } from "react";
import "./about.css"

export default function About(){
    useEffect(() => {
        window.scrollTo(0, 0);
        return () => {
            window.scrollTo(0, 0);
        };
    }, []);
    return(
        <>
        <div className="wrapper container " >
            <div className="aboutHeader about">
                <p className="subTitle">About us</p>
                <h2 className="mainTitle">The Journey of a Lifetime: Craft Unforgettable Memories with Travelwise</h2>
            </div>
            <section className="aboutContant">
                <figure>
                    <img src="../images/about.webp" alt="Travel wise"/>
                </figure>
                <main>
                    <h3 className="subTitle">We Are Trusted</h3>
                    <h2 className="mainTitle">The Wanderer's Guide: Expert Travel Planning with Travelwise</h2>
                    <p className="content">At Travelwise, our team of travel experts is dedicated to crafting personalized itineraries that cater to your unique needs and preferences. We ensure every moment of your journey is an unforgettable experience, filled with seamless planning and luxurious touches.
                        <br/><br/>
                        Don’t let the adventure of a lifetime pass you by. Book with Travelwise today and prepare for a breathtaking journey that will create memories to last forever!</p>
                    <aside>
                        <div>
                            <h4>750+</h4>
                            <p>Trips</p>
                        </div>
                        <div>
                            <h4>7k</h4>
                            <p>Happy Clients</p>
                        </div>
                        <div>
                            <h4>50+</h4>
                            <p>Countires</p>
                        </div>
                    </aside>
                </main>
            </section>
            <section className="wrapper container benefits">
                {/* <h4>Why Choose Travel&nbsp;Wise?</h4>
                <h2>Unforgettable Adventures and Lasting Memories</h2> */}
                <main>
                    <aside>
                        <figure>
                            <img src="../images/package.webp" alt="packages"/>
                        </figure>
                        <h3>All-Inclusive Packages</h3>
                        <p>Experience hassle-free vacations with Travel&nbsp;Wise’s all-inclusive packages, covering everything.</p>
                    </aside>

                    <aside>
                        <figure>
                            <img src="../images/insurance.webp" alt="packages"/>
                        </figure>
                        <h3>Comprehensive Insurance</h3>
                        <p>Travel with peace of mind knowing that we offer comprehensive travel insurance options.</p>
                    </aside>

                    <aside>
                        <figure>
                            <img src="../images/perks.webp" alt="packages"/>
                        </figure>
                        <h3>Perks & VIP Benefits</h3>
                        <p>As a Travel&nbsp;Wise customer, enjoy VIP treatment, including priority boarding, complimentary upgrades</p>
                    </aside>
                </main>
            </section>
            <section className="wrapper parallax"/>
            <div className="about aboutService">
                <div className="aboutServiceHeader">
                    <p className="subTitle">Why Choose Us</p>
                    <h2 className="mainTitle">Unforgettable Journeys: Where Memories Are Made</h2>
                </div>
                <figure>
                    <img src="../images/aboutMaps.webp" alt="Travel Wise"/>
                </figure>
                <h2 style={{marginBottom:"2rem", width:"80%"}}>Services We Provide</h2>
                <main>
                    <ul>
                        <li>Customized Itinerary Planning</li>
                        <li>Flight and Accommodation Bookings</li>
                        <li>Group Travel Planning</li>
                    </ul>
                    <ul>
                        <li>Destination Tours and Excursions</li>
                        <li>Travel Insurance</li>
                        <li>Luxury Travel Experiences</li>
                    </ul>
                    <ul>
                        <li>Honeymoon and Romantic Getaways</li>
                        <li>Visa and Travel Documentation Assistance</li>
                        <li>24/7 Customer Support</li>
                    </ul>
                </main>
            </div>
        </div>
        </>
    )
}